import React, { useState, useEffect } from 'react';
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import TitleBar from "../components/TitleBar";

const StaticPage = ({ alias, staticPage, homepageBanners }) => {
    const [staticContent, setStaticContent] = useState([]);
    const {t, i18n} = useTranslation();

    useEffect(() => {
        if (staticPage.length > 0) {
            for (let i = 0; i < staticPage.length; i++) {
                if (staticPage[i].alias == alias) {
                    setStaticContent([staticPage[i]]);
                    break;
                }
                else if (homepageBanners.length > 0) {
                    for (let j = 0; j < homepageBanners.length; j++) {
                        if (homepageBanners[j].alias == alias) {
                            setStaticContent([homepageBanners[j]]);
                            break;
                        }
                    }
                }
                else {
                    setStaticContent(null);
                }
            }
        }
    }, [alias, staticPage, homepageBanners]);

    return (
        <section className="mainContents mainContents2">
            <div>
                {staticContent && staticContent.length > 0 && (
                    <section className="mainContents mainContents2">
                        <TitleBar
                            title = {staticContent[0].name[i18n.language]}
                        />
                        <div id="page-whats-cb">
                            <section className='content-container'>
                                <div className="container">
                                    <div className="row">
                                        <div className="col">
                                            <div
                                                dangerouslySetInnerHTML={{ __html: staticContent[0].content[i18n.language]}}
                                            >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                )}
            </div>
        </section>
    )
}

const mapStateToProps = state => ({
    staticPage: state.shared.static_page,
    homepageBanners: state.shared.homepage_banners,
});
export default connect(mapStateToProps)(StaticPage);
